import React, { Fragment } from 'react'

import styles from './CopyInput.module.css'
import CopyIcon from 'Icons/copy.svg'
import CopiedIcon from 'Icons/check.svg'

import Input from 'Design/components/Input'
import useClipboard from 'Utils/hooks/useClipboard'

const CopyInput = (props) => {
  const { canCopy = true, value = '' } = props

  const { copy, copied } = useClipboard()

  return (
    <div className={styles.CopyInput}>
      <Input value={value} disabled />
      {canCopy && (
        <span className={styles.CopyIconContainer} onClick={() => copy(value)}>
          <Fragment>
            {copied && (
              <Fragment>
                <CopiedIcon /> Copied
              </Fragment>
            )}
            {!copied && (
              <Fragment>
                <CopyIcon /> Copy token
              </Fragment>
            )}
          </Fragment>
        </span>
      )}
    </div>
  )
}

export default CopyInput
